<template>
  <div class="artwork"></div>
</template>

<script>
import { TweenMax, Power1 } from 'gsap/TweenMax';
import { mapGetters } from 'vuex';
import * as PIXI from 'pixi.js';

import { viewportSize, isMobile } from '@/scripts/utils';
import animations from '@/scripts/animations';

export default {
  name: 'Artwork',

  data() {
    return {
      lang: this.$store.state.lang,
      app: null,
      sprites: new Map(),
      displacement: null,
      dmap: null,
      ArtworkLoader: null,
      setted: false,
      isMobile,

      container: null,
      prevWidth: 0,

      pixiReady: false,
      PIXI: null,
    };
  },

  computed: {
    ...mapGetters({
      hoverEvent: 'getHoverEvent',

      currentEvent: 'getEventName',

      eventsList: 'getEventsList',

      loaded: 'getPageLoaded',
    }),
  },

  watch: {
    hoverEvent(newVal, oldVal) {
      const newValString = newVal.toString();
      const oldValString = !oldVal ? oldVal : oldVal.toString();

      if (newVal) {
        this.firstEnter = false;
        const newSprite = this.sprites.get(newValString);

        if (this.setted) {
          let delay = 0.1;
          if (oldValString) delay = 0.2;

          animations.get('canvasHover')(newSprite, this.displacement, delay).play().timeScale(0.75);
        } else {
          const intervalEvent = setInterval(() => {
            if (this.setted) {
              let delay = 0.1;
              if (oldValString) delay = 0.2;

              animations.get('canvasHover')(newSprite, this.displacement, delay).play().timeScale(0.75);
              clearTimeout(intervalEvent);
            }
          }, 500);
        }
      }

      if (oldValString) {
        const oldSprite = this.sprites.get(oldValString);
        const speed = newVal !== null ? 0.25 : 0.75;

        TweenMax.killTweensOf(oldSprite);
        TweenMax.to(oldSprite, speed, {
          alpha: 0,
          y: 35,
        });
      }
    },

    eventsList(newVal) {
      if (newVal && !this.setted) {
        if (this.pixiReady) this.init();
      }
    },
  },

  mounted() {
    this.pixiReady = true;
    this.PIXI = PIXI;
    this.PIXI.utils.skipHello();

    const xPercent = window.innerWidth < 1024 && window.innerWidth > 767 ? -40 : -50;

    TweenMax.set(this.$el, {
      yPercent: -50,
      xPercent,
    });
    console.log(PIXI);

    this.init();

    if (this.setted) this.$eventHub.$on('windowResized', this.setPosArtwork);
    if (this.setted) this.$eventHub.$on('windowResized', this.refreshCanvas);
  },

  methods: {
    init() {
      this.app = new this.PIXI.Application({
        width: Math.min(800, viewportSize().width),
        height: Math.min(800, viewportSize().width),
        transparent: true,
      });

      this.prevWidth = this.app.renderer.width;


      this.$el.appendChild(this.app.view);

      this.ArtworkLoader = new this.PIXI.loaders.Loader();

      this.eventsList[this.lang].forEach((event) => {
        if (event.id === 'event02' || event.id === 'event04' || event.id === 'event05' || event.id === 'event07') {
          this.ArtworkLoader.add(`${event.id}_01`, `/static/img/artwork/${event.id}_01.png`);
          this.ArtworkLoader.add(`${event.id}_02`, `/static/img/artwork/${event.id}_02.png`);
        } else {
          this.ArtworkLoader.add(event.id, `/static/img/artwork/${event.id}.png`);
        }
      });

      this.ArtworkLoader.add('dmap', '/static/img/artwork/dmap.jpg');

      this.ArtworkLoader.load(() => {
        this.setted = true;
        this.setup();
      });
    },

    setup() {
      this.container = new this.PIXI.Container();

      this.eventsList[this.lang].forEach((event) => {
        const permalink = event.id;
        let sprite;
        let sprite2 = null;

        if (event.id === 'event02' || event.id === 'event04' || event.id === 'event05' || event.id === 'event07') {
          sprite = new this.PIXI.Sprite(this.ArtworkLoader.resources[`${permalink}_01`].texture);
          sprite2 = new this.PIXI.Sprite(this.ArtworkLoader.resources[`${permalink}_02`].texture);
          sprite.name = `${event.id}_01`;
          sprite.name2 = `${event.id}_02`;
        } else {
          sprite = new this.PIXI.Sprite(this.ArtworkLoader.resources[permalink].texture);
          sprite.name = event.id;
        }

        const containerSprite = new this.PIXI.Container();

        const width = sprite.width;

        sprite.scale.set(this.app.renderer.width / width);
        if (sprite2 !== null) sprite2.scale.set(this.app.renderer.width / width);

        sprite.x = (this.app.renderer.width / 2) - (sprite.width / 2);
        sprite.y = (this.app.renderer.height / 2) - (sprite.height / 2);

        if (sprite2 !== null) {
          sprite2.x = (this.app.renderer.width / 2) - (sprite.width / 2);
          sprite2.y = (this.app.renderer.height / 2) - (sprite.height / 2);
        }

        containerSprite.addChild(sprite);
        if (sprite2 !== null) containerSprite.addChild(sprite2);

        TweenMax.set(containerSprite, { alpha: 0 });

        TweenMax.fromTo(sprite, 5, {
          x: '+=20',
        }, {
          x: '-=15',
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut,
        });

        TweenMax.fromTo(sprite, 3.2, {
          y: '+=10',
        }, {
          y: '-=7',
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut,
        });

        if (sprite2 !== null) {
          TweenMax.fromTo(sprite2, 3, {
            x: '-=4',
          }, {
            x: '+=14',
            yoyo: true,
            repeat: -1,
            ease: Power1.easeInOut,
          });

          TweenMax.fromTo(sprite2, 4.8, {
            y: '-=22',
          }, {
            y: '+=12',
            yoyo: true,
            repeat: -1,
            ease: Power1.easeInOut,
          });
        }

        this.sprites.set(permalink, containerSprite);

        this.container.addChild(containerSprite);
      });


      this.ArtworkLoader.resources.dmap.texture.wrapMode = this.PIXI.WRAP_MODES.REPEAT;

      this.dmap = new this.PIXI.Sprite(this.ArtworkLoader.resources.dmap.texture);
      this.dmap.name = 'dmap';

      this.displacement = new this.PIXI.filters.DisplacementFilter(this.dmap);

      this.displacement.autoFit = true;
      this.container.filters = [this.displacement];
      this.app.stage.addChild(this.container);
    },

    setPosArtwork() {
      if (!this.loaded) return;
      const artwork = this.$el;

      const contW = document.querySelector('[js-pagecontainer]').getBoundingClientRect().width;
      const contH = document.querySelector('[js-pagecontainer]').getBoundingClientRect().height;
      const windowW = window.innerWidth;
      const artworkW = artwork.getBoundingClientRect().width;

      const tXa = (windowW <= 767 && this.$store.state.route.name !== 'home') ? 0 : (contW - (artworkW * 0.8));
      const tXaF = (this.$store.state.route.name === 'home') ? 0 : (tXa / 2);

      // const tYaP = (windowW <= 767 && this.$store.state.route.name !== 'home') ? -105 : -50;
      const scaleP = (this.$store.state.route.name !== 'home') ? 0.8 : 1;
      const tYa = (windowW <= 767) ? ((contH - (artwork.getBoundingClientRect().height * 0.8)) / 2) + (artwork.getBoundingClientRect().height / 5.5) : 0; // eslint-disable-line

      TweenMax.to(artwork, 0.8, {
        x: tXaF,
        xPercent: -50,
        yPercent: -50,
        y: -tYa,
        scale: scaleP,
        ease: Power1.easeInOut,
      });
    },

    refreshCanvas() {
      this.app.renderer.resize(
        Math.min(800, viewportSize().width), Math.min(800, viewportSize().width));

      this.container.scale.set(this.app.renderer.width / this.prevWidth);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../application';

.artwork {
  position: fixed;
  top: 50%;
  left: 50%;

  text-align: center;

  pointer-events: none;
  z-index: 3;

  @include mq(sm) {
    position: absolute;
  }

  [js-view="event"] & {
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Artwork.vue